import { render, staticRenderFns } from "./Part-3.vue?vue&type=template&id=002d3bcf&"
import script from "./Part-3.vue?vue&type=script&lang=js&"
export * from "./Part-3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports